import {
  AuthError,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { loginRequest, msalConfig } from "./authConfig"
import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import { navigate } from "@reach/router"
import { CustomNavigationClient } from "../../Utils/NavigationClient"
import React from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const msalInstance = new PublicClientApplication(msalConfig)

const Provider = ({ element }) => {
  // The next 2 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigationClient = new CustomNavigationClient()
  msalInstance.setNavigationClient(navigationClient)

  const callbackId = msalInstance.addEventCallback((message: EventMessage) => {
    // console.log(message.eventType)
    if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      if (message.error instanceof AuthError) {
        console.log("EventType.ACQUIRE_TOKEN_FAILURE")
        console.log(message.error.message)
        msalInstance.logoutRedirect()
        // navigate("/app/")
        // if (message.error.message.includes("AADB2C90091")) navigate("/app/")
      }
    }

    if (message.eventType === EventType.LOGIN_FAILURE) {
      if (message.error instanceof AuthError) {
        console.log("EventType.LOGIN_FAILURE")
        console.log(message.error.message)
        const request = {
          ...loginRequest,
        }
        msalInstance.acquireTokenRedirect(request)
      }
    }

    if (message.eventType === EventType.HANDLE_REDIRECT_END) {
      if (message.error instanceof AuthError) {
        console.log("EventType.HANDLE_REDIRECT_END")
        console.log(message.error.message)
        const request = {
          ...loginRequest,
        }
        msalInstance.acquireTokenRedirect(request)
        // if (message.error.message.includes("AADB2C90091")) navigate("/app/")
      }
    }
  })

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        icon={true}
      />
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          {element}
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MsalProvider>
    </>
  )
}

export default Provider
